import { render, staticRenderFns } from "./comp_lateral_menu.vue?vue&type=template&id=1d5ebeaa&"
import script from "./comp_lateral_menu.vue?vue&type=script&lang=js&"
export * from "./comp_lateral_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports